<template>
  <div>
    <!-- <div class="checkbox">
      <el-checkbox v-for="(item,index) in list" v-model="item.value">{{item.label}}</el-checkbox>
    </div> -->
    <el-table
      :data="tableData"
      :border="border"
      :height="height"
      :max-height="maxHeight"
      :size="size"
      :stripe="stripe"
      :fit="fit"
      :show-header="showHeader"
      :highlight-current-row="highlightCurrentRow"
      :row-class-name="rowClassName"
      :header-cell-style="headerCellStyle"
      @select="onSelect"
      @select-all="onSelectAll"
      @selection-change="onSelectionChange"
      @cell-mouse-enter="cellMouseEnter"
      @cell-mouse-leave="cellMouseLeave"
      @cell-click="cellClick"
      @cell-dblclick="cellDblclick"
      @row-click="rowClick"
      @row-contextmenu="rowContextmenu"
      @row-dblclick="rowDblclick"
      @header-click="headerClick"
      @header-contextmenu="headerContextmenu"
      @sort-change="sortChange"
      @filter-change="filterChange"
      @current-change="currentChange"
      @header-dragend="headerDragend"
      @expand-change="expandChange"
    >
      <el-table-column
        v-if="firstColumn"
        :type="firstColumn"
        width="55"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="序列"
        :type="'index'"
        width="55"
        align="center"
      >
      </el-table-column>
      <el-table-column
        v-for="(item, index) in list"
        v-if="item.value"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :width="index + 1 != list.length ? item.width : (item.width || 150)"
        :align="item.align || 'center'"
        :fixed="item.fixed || false"
      >
        <template slot-scope="scope">
          <!-- 默认展示方案 -->
          <span v-if="!item.customType">{{scope.row[item.prop] || scope.row[item.prop] == 0 ? scope.row[item.prop] : '--'}}</span>
          <!-- 自定义dom方案 -->
          <div 
            v-else-if="item.customType && item.customType == 'custom-dom'" 
            v-html="item.customRender(scope)"
          ></div>
          <!-- table内置组件 -->
          <component
            v-else-if="item.customType && item.customType == 'table-image'"
            :is="item.customType"
            :urls="item.urls"
          ></component>
          <component
            v-else-if="item.customType && item.customType == 'table-switch'"
            :is="item.customType"
            :scope="scope"
            :value="scope.row.active ? true : false"
            @customBindClick="item.customBindClick"
          ></component>
          <div class="btn-list" v-else-if="item.customType && item.customType == 'table-btn'">
            <component
              v-for="(itm,idx) in item.customBtnList"
              :is="item.customType"
              :key="idx"
              :scope="scope"
              :custom="itm"
            ></component>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" v-if="pageConfig && tableData.length > 0">
      <el-pagination
        background
        :current-page="pageConfig.pageNo"
        :page-size="pageConfig.pageSize"
        :total="pageConfig.total"
        :page-sizes="pageConfig.pageItem || [10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageConfig.handleSizeChange"
        @current-change="pageConfig.handleCurrentChange"></el-pagination>
    </el-col>
  </div>
</template>
<script>
import tableBtn from './components/button'
import tableImage from './components/image'
import tableSwitch from './components/switch'
export default {
  components:{
    tableBtn,
    tableImage,
    tableSwitch
  },
  props: {
    // 自定义
    firstColumn: {
      type: String,
      default: null
    },
    // 渲染数据
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 自定义table列表
    config: {
      type: [Object,Array],
      default: () => {
        return null
      }
    },
    pageConfig: {
      type: Object,
      default: () => {
        return null
      }
    },
    border: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String],
      default: null,
    },
    size: {
      type: String,
      default: 'medium'
    },
    stripe: {
      type: Boolean,
      default: false
    },
    fit: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: [Number, String],
      default: null
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true
    },
    headerCellStyle: {
      type: Object,
      default: ()=>{return {}}
    },
    currentRowKey: {
      type: [String, Number],
      default: null
    },
    rowClassName: {
      type: [Function, String],
      default: null
    },
  },
  watch: {
    config(newValue,oldValue) {
      this.list = this.config.length ? this.setCheckboxList(newValue) : this.setCheckboxList(this.resetConfig(newValue))
    }
  },
  data() {
    return {
      list: this.config.length ? this.setCheckboxList(this.config) : this.setCheckboxList(this.resetConfig(this.config))
    }
  },
  methods: {
    onSelect(selection, row) {
      this.$emit('onSelect', selection, row)
    },
    onSelectAll(selection) {
      this.$emit('onSelectAll', selection)
    },
    onSelectionChange(selection) {
      this.$emit('onSelectionChange',selection)
    },
    cellMouseEnter(row, column, cell, event) {
      this.$emit('cellMouseEnter',row, column, cell, event)
    },
    cellMouseLeave(row, column, cell, event) {
      this.$emit('cellMouseLeave',row, column, cell, event)
    },
    cellClick(row, column, cell, event) {
      this.$emit('cellClick',row, column, cell, event)
    },
    cellDblclick(row, column, cell, event) {
      this.$emit('cellDblclick',row, column, cell, event)
    },
    rowClick(row, column, event) {
      this.$emit('rowClick', row, column, event)
    },
    rowContextmenu(row, column, event) {
      this.$emit('rowContextmenu', row, column, event)
    },
    rowDblclick(row, column, event) {
      this.$emit('rowDblclick', row, column, event)
    },
    headerClick(column, event) {
      this.$emit('headerClick', column, event)
    },
    headerContextmenu(column, event) {
      this.$emit('headerContextmenu', column, event)
    },
    sortChange(params) {
      this.$emit('sortChange', params)
    },
    filterChange(filters) {
      this.$emit('filterChange', filters)
    },
    currentChange(currentRow, oldCurrentRow) {
      this.$emit('currentChange', currentRow, oldCurrentRow)
    },
    headerDragend(newWidth, oldWidth, column, event) {
      this.$emit('headerDragend', newWidth, oldWidth, column, event)
    },
    expandChange(row) {
      this.$emit('expandChange', row)
    },
    setCheckboxList(arr) {
      // console.log(arr)
      let list = []
      arr.map(item => {
  
        item.value = true
        // list.push(obj)
      })
      return arr
    },
    resetConfig (config) {
      let obj = {...config}
      let array = []
      obj.prop.map((item, index) => {
        let aItem = {
          prop: item,
          label: obj.label[index]
        }
        obj.custom.map((itm,idx) => {
          if(itm.prop == item) {
            Object.assign(aItem, itm)
          }
        })
        array.push(aItem)
      })
      // console.log(config)
      return array
    },
  }
}
</script>
<style lang="scss" scoped>
  .btn-list {
    display: flex;
    justify-content: center;
    algin-items: center
  }
  .el-table--medium th {
    padding: 15px 0;
  }
</style>